import React from "react";

const BackHeader = ({ title, onBack }) => {
    return (
        <div className="flex items-center gap-4 bg-white border-b border-gray-50 px-6 py-4 rounded-2xl mb-8 shadow-[0_2px_10px_-4px_rgba(0,0,0,0.05)]">
            <button
                onClick={onBack}
                className="p-2 -ml-2 text-gray-400 hover:text-gray-900 hover:bg-gray-50 rounded-xl transition-all active:scale-95 flex items-center justify-center group"
                aria-label="Go back"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-5 h-5 group-hover:-translate-x-1 transition-transform"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                    />
                </svg>
            </button>
            <h2 className="text-lg font-bold text-gray-900 m-0 tracking-tight">{title}</h2>
        </div>
    );
};

export default BackHeader;
